var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCycleFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 1C17.5052 1 22.25 5.82514 22.25 11.75C22.25 17.6749 17.5052 22.5 11.625 22.5C5.74485 22.5 1 17.6749 1 11.75C1 5.82514 5.74485 1 11.625 1Z",
    fill: "#FFD31F",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22917 5.89067V7.69815C8.33277 6.58229 9.8819 5.89067 11.5625 5.89067C14.8762 5.89067 17.5625 8.57697 17.5625 11.8907V12.3907H16.5625V11.8907C16.5625 9.12925 14.3239 6.89067 11.5625 6.89067C10.0799 6.89067 8.71957 7.53521 7.79237 8.55734H9.89583V9.55734H6.22917V5.89067H7.22917ZM6.5625 11.3907V11.8907C6.5625 14.6521 8.80107 16.8907 11.5625 16.8907C13.0451 16.8907 14.4054 16.2461 15.3326 15.224H13.237V14.224H16.9037V17.8907H15.9037V16.0752C14.7996 17.1957 13.2471 17.8907 11.5625 17.8907C8.24879 17.8907 5.5625 15.2044 5.5625 11.8907V11.3907H6.5625Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCycleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CycleFilled.88227fdf2bd2e6e7721cf17e880a9145.svg";